import {Icon, Stack, Heading, Text} from '@primer/react-brand'
import {getPrimerIcon} from '../../lib/utils/icons'
import type {FeatureListItem} from '../../schemas/contentful/contentTypes/featureListItem'

export type FeatureListProps = {
  items: FeatureListItem[]
  className?: string
  iconClassName?: string
}

export function FeatureList({items, className, iconClassName}: FeatureListProps) {
  return (
    <Stack direction="vertical" gap="none" padding="none" alignItems="flex-start" className={className}>
      {items.map((item, idx) => {
        const Octicon = getPrimerIcon(item.fields.icon)

        const key = `${item.sys?.id ?? item.fields.heading ?? 'feature'}-${idx}`

        return (
          <Stack key={key} direction="horizontal" gap="condensed" alignItems="flex-start">
            {Octicon && (
              <Icon
                icon={<Octicon />}
                size="small"
                hasBackground
                color="green"
                className={iconClassName}
                data-testid={`${item.fields.icon}-icon-${item.sys?.id ?? idx}`}
              />
            )}

            <Stack direction="vertical" padding="none" gap="none" alignItems="flex-start">
              {item.fields.heading && (
                <Heading as="h2" size="subhead-medium" className="mb-0">
                  {item.fields.heading}
                </Heading>
              )}

              {item.fields.description && (
                <Text as="p" variant="muted" className="mb-0">
                  {item.fields.description}
                </Text>
              )}
            </Stack>
          </Stack>
        )
      })}
    </Stack>
  )
}

export default FeatureList
